import { Spin } from "antd";
import { useState } from "react";
import { useBalanceCheckQuery } from "../../features/portal/vendorPayment/vendorPaymentApi";
import useError from "../../hooks/useError";
import { addCommaInNumber } from "../../utils/number";
import BalanceSlide from "./BalanceSlide";

type WalletBalanceCheckerProps = {
  wallet_number: string;
  company_id: number;
};

const WalletBalanceChecker: React.FC<WalletBalanceCheckerProps> = ({
  wallet_number,
  company_id,
}) => {
  const [isClicked, setIsClicked] = useState(false);

  const {
    data: balanceCheck,
    isLoading,
    isError,
    error,
  } = useBalanceCheckQuery(
    {
      walletNumber: wallet_number,
      companyId: company_id,
    },
    {
      skip: !isClicked || !wallet_number || !company_id,
    }
  );

  const amount = balanceCheck?.data?.data?.Amount || 0;

  useError(isError, error, "Get balance data fail");

  return (
    <div className="flex justify-center items-center">
      {isLoading ? (
        <Spin />
      ) : (
        <div onClick={() => setIsClicked(true)}>
          <BalanceSlide>
            {isClicked
              ? `${addCommaInNumber(Math.round(amount))} BDT`
              : "Check Balance"}
          </BalanceSlide>
        </div>
      )}
    </div>
  );
};

export default WalletBalanceChecker;
